import React from "react";
import { getHedgerDuedateXYPlot } from "src/Requests/automaticMarketMaking";
import useRequest from "src/Hooks/useRequest";
import { IIVOptionSearchParams } from "src/Interfaces/automaticMarketMaking";
import ScatterLineChart from "src/Components/Charts/ScatterLineChart";

interface IProps {
  searchParam: IIVOptionSearchParams;
}

const HedgerDuedateChart: React.FC<IProps> = ({ searchParam }) => {
  const chartRequest = useRequest(
    () => getHedgerDuedateXYPlot(searchParam),
    () => {}
  );

  const isEmpty = React.useMemo(() => {
    if (searchParam.accountId && searchParam.toDate && searchParam.baseInsId)
      return false;
    return true;
  }, [searchParam]);

  React.useEffect(() => {
    if (isEmpty) return;
    chartRequest.fetchData();
    const interval = setInterval(() => {
      chartRequest.fetchData();
    }, 30000);
    return () => clearInterval(interval);
  }, [searchParam, isEmpty]);

  return (
    <div
      className="w-1/2 h-1/2 justify-center items-center align-middle relative min-h-[280px]"
      onClick={(e) => e.stopPropagation()}
    >
      <ScatterLineChart
        series={chartRequest.response?.series || []}
        titleX={chartRequest.response?.titleX}
        titleY={chartRequest.response?.titleY}
      />
    </div>
  );
};

export default HedgerDuedateChart;
